module.exports = __webpack_public_path__ + "img/logo.52611c73.svg";